import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5199dc01"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "card py-5 px-5 mb-3" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "d-flex gap-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-3" }, null, -1))
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = {
  key: 0,
  class: "card-title d-flex justify-content-between",
  style: {"width":"100%"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Dealing 審核", -1))
const _hoisted_10 = { class: "card-body py-4" }
const _hoisted_11 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_12 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "text-center cell-color" }
const _hoisted_15 = {
  key: 1,
  class: "cell-color text-center"
}
const _hoisted_16 = {
  key: 2,
  class: "cell-color text-center"
}
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "d-flex align-items-center gap-2" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-info ms-3 cursor-pointer"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "text-center cell-color" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 1,
  class: "cell-color text-center"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "text-center cell-color" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = ["disabled", "onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  class: "card mt-5"
}
const _hoisted_49 = { class: "card-header" }
const _hoisted_50 = {
  key: 0,
  class: "card-title"
}
const _hoisted_51 = { class: "card-body py-4" }
const _hoisted_52 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_53 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { class: "text-center cell-color" }
const _hoisted_56 = { class: "cell-color text-center" }
const _hoisted_57 = { class: "cell-color text-center" }
const _hoisted_58 = { class: "cell-color text-center" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_62 = { class: "d-flex align-items-center" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "d-flex align-items-center gap-2" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-primary"
}
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["onClick"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = {
  key: 0,
  class: "badge badge-primary"
}
const _hoisted_71 = ["onClick"]
const _hoisted_72 = {
  key: 0,
  class: "fa-regular fa-comment-dots text-info ms-3 cursor-pointer"
}
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "text-center cell-color" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = {
  key: 1,
  class: "cell-color text-center"
}
const _hoisted_77 = { class: "text-center cell-color" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["onClick"]
const _hoisted_81 = { class: "text-center cell-color" }
const _hoisted_82 = ["onClick"]

import moment from "moment/moment";
import { ref, onMounted, inject, watch, provide } from "vue";
import NewWithdrawalRequestModal from "@/projects/tenant/modules/Payment/components/modal/NewWithdrawalRequestModal.vue";
import WithdrawalPaymentInfoVerify from "@/projects/tenant/modules/Payment/modal/WithdrawalPaymentInfoVerify.vue";
import { isDateInDST_US } from "@/core/plugins/TimerService";
import svc from "../services/PaymentService";
import TenantGlobalService, {
  CreateReportSpec,
} from "@/projects/tenant/services/TenantGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import {
  TransactionStateType,
  WithdrawalStatusType,
  WithdrawalStateTypes,
  TransactionAccountType,
} from "@/core/types/StateInfos";
import { TransactionAccountTypes } from "@/core/types/AccountInfos";
import { CommentType } from "@/core/types/CommentType";
import WithdrawInfo from "../modal/WithdrawInfo.vue";
import CommentsView from "@/projects/tenant/components/CommentView.vue";
import ChangeStatusModal from "../modal/ChangeStatusModal.vue";
import {
  PaymentInfoStatusTypes,
  PaymentStatusTypes,
} from "@/core/types/PaymentTypes";
import { ActionType } from "@/core/types/Actions";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import ConfirmCommentBox from "@/components/ConfirmCommentBox.vue";
import ConfirmBox from "@/components/ConfirmBox.vue";
import { convertTradeTime } from "@/core/helpers/helpers";
import HeaderMenu from "../components/HeaderMenu.vue";
import { Document } from "@element-plus/icons-vue";
import HistoryRecord from "../components/modal/HistoryRecord.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawIndex',
  setup(__props) {

const historyRef = ref<any>(null);
const newWithdrawalRequestModalRef = ref<any>();
const withdrawalPaymentInfoVerifyRef =
  ref<InstanceType<typeof WithdrawalPaymentInfoVerify>>();
const TabStatus = WithdrawalStatusType;
const isLoadingAll = ref(false);
const isLoading = ref(false);
const isDealingLoading = ref(false);
const isSubmitting = ref(false);
provide("isLoading", isLoading);
const WithdrawInfoRef = ref<InstanceType<typeof WithdrawInfo>>();
const changeStatusRef = ref<InstanceType<typeof ChangeStatusModal>>();
const commentsRef = ref<InstanceType<typeof CommentsView>>();
const exporting = ref(false);
const tab = ref<any>(TabStatus.Pending);
const action = ref(ActionType.Cancel);
const processTransaction = ref(() => Promise.resolve());
const headerMenuRef = ref<InstanceType<typeof HeaderMenu>>();
const data = ref(Array<any>());
const dataDealing = ref(<any>[]);
const viewingFromDealing = ref(false);

const criteria = ref<any>({
  page: 1,
  size: 10,
  stateId: TransactionStateType.WithdrawalCreated,
  sortField: "createdOn",
});

const dealingCriteria = ref<any>({
  page: 1,
  size: 10,
  stateId: TransactionStateType.WithdrawalTenantApproved,
  sortField: "createdOn",
});
const period = ref([] as any);

const changeTab = (_tab: any) => {
  tab.value = _tab;
  if (tab.value == TabStatus.All) {
    criteria.value.stateId = null;
  } else criteria.value.stateId = tab.value;
  fetchData(1);
  if (tab.value == TabStatus.Pending) {
    fetchDealingData(1);
  }
};

const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  isLoading.value = true;
  try {
    const res = await svc.queryWithdrawals(criteria.value);
    criteria.value = res.criteria;
    data.value = res.data;
  } catch (error) {
    console.error("Error fetching withdrawal data:", error);
    // 如果发生错误，设置空数据
    data.value = [];
    criteria.value = {
      ...criteria.value,
      total: 0,
      pageCount: 1,
      hasMore: false,
    };
  } finally {
    isLoading.value = false;
  }
};

const fetchDealingData = async (_page: number) => {
  isDealingLoading.value = true;
  dealingCriteria.value = {
    ...criteria.value,
    stateId: TransactionStateType.WithdrawalTenantApproved,
  };
  dealingCriteria.value.page = _page;
  try {
    const res = await svc.queryWithdrawals(dealingCriteria.value);
    dealingCriteria.value = res.criteria;
    dataDealing.value = res.data;
  } catch (error) {
    console.error("Error fetching dealing data:", error);
    dataDealing.value = [];
    dealingCriteria.value = {
      ...dealingCriteria.value,
      total: 0,
      pageCount: 1,
      hasMore: false,
    };
  } finally {
    isDealingLoading.value = false;
  }
};
const confirmSearch = () => {
  if (tab.value != TabStatus.All) {
    headerMenuRef.value?.changeTab(TabStatus.All);
  } else {
    fetchData(1);
  }
};

const clearSearchFilterCriteria = () => {
  criteria.value = {
    page: 1,
    size: 10,
    SortField: "updatedOn",
    stateId: tab.value,
  };
  if (tab.value == TabStatus.All) {
    criteria.value.stateId = null;
  }
  period.value = [];
  fetchData(1);
};
watch(
  () => period.value,
  (periodVal) => {
    if (periodVal && periodVal.length > 0) {
      const [from, to] = convertTradeTime(periodVal[0], periodVal[1]);
      criteria.value.from = from;
      criteria.value.to = to;
    } else {
      criteria.value.from = null;
      criteria.value.to = null;
    }
  }
);
const formData = ref<CreateReportSpec>({
  name: "",
  type: ReportRequestTypes.WithdrawForTenant,
  query: criteria.value,
});

const submitReportRequest = async () => {
  exporting.value = true;
  formData.value.type =
    tab.value == TabStatus.Pending
      ? ReportRequestTypes.WithdrawPendingForTenant
      : ReportRequestTypes.WithdrawForTenant;

  const [from, to] = period.value ?? [null, null];

  const [createdFrom, createdTo] = convertTradeTime(from, to);

  formData.value.query = {
    from: createdFrom,
    to: createdTo,
    stateId: criteria.value.stateId,
  };

  try {
    const media = await TenantGlobalService.createReportRequestDownload(
      formData.value
    );
    await TenantGlobalService.downloadFileByGuid(media.guid, media.fileName);
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    exporting.value = false;
  }
};

const pageChange = (page: number) => {
  fetchData(page);
};

const showWithdrawInfo = async (_item: any) => {
  viewingFromDealing.value =
    _item?.stateId === TransactionStateType.WithdrawalCreated;
  WithdrawInfoRef.value?.show(_item);
};

const getWithdrawalPaymentInfo = (_item: any) =>
  _item?.paymentInfo ?? _item?.payementInfo;

const getWithdrawalPaymentInfoStatus = (_item: any) => {
  const status = getWithdrawalPaymentInfo(_item)?.status;
  if (status === undefined || status === null || status === "") return null;
  const normalizedStatus = Number(status);
  return Number.isNaN(normalizedStatus) ? null : normalizedStatus;
};

const canVerifyPaymentInfo = (_item: any) => {
  const status = getWithdrawalPaymentInfoStatus(_item);
  return (
    status === PaymentInfoStatusTypes.tradeAccountVerify ||
    status === PaymentInfoStatusTypes.walletVerify ||
    status === PaymentInfoStatusTypes.waitingForVerfied
  );
};

const isPaymentInfoVerified = (_item: any) => {
  const status = getWithdrawalPaymentInfoStatus(_item);
  return (
    status === PaymentInfoStatusTypes.verfied ||
    status === PaymentInfoStatusTypes.tradeAccountVerified ||
    status === PaymentInfoStatusTypes.walletVerified
  );
};

const isPaymentInfoVerifyFailed = (_item: any) => {
  const status = getWithdrawalPaymentInfoStatus(_item);
  return (
    status === PaymentInfoStatusTypes.verifyFailed ||
    status === PaymentInfoStatusTypes.tradeAccountVerifiedFailed ||
    status === PaymentInfoStatusTypes.walletVerfiedFailed
  );
};

const openPaymentInfoVerifyPanel = (_item: any) => {
  const paymentInfo = getWithdrawalPaymentInfo(_item);
  if (!paymentInfo) return;
  withdrawalPaymentInfoVerifyRef.value?.show(_item.id, paymentInfo, {
    readonly: isPaymentInfoVerified(_item) || isPaymentInfoVerifyFailed(_item),
  });
};

const viewComments = (type: CommentType, id: number, title: string) => {
  commentsRef.value?.show(type, id, title);
};

const openConfirmBox = inject<any>(InjectKeys.OPEN_CONFIRM_MODAL);
const openRejectBox = inject(InjectKeys.OPEN_REJECT_REASON_MODAL);
const confirmCommentBoxRef = ref<InstanceType<typeof ConfirmCommentBox>>();

const openConfirmPanel = (
  _action: ActionType,
  id: number,
  paymentID?: number
) => {
  action.value = _action;
  const _handler = {
    [ActionType.CompletePayment]: () => {
      if (!paymentID) {
        return Promise.reject(new Error("Payment ID is required"));
      }
      return svc
        .completePaymentById(paymentID)
        .then(() => svc.completeWithdrawalByPaymentId(id));
    },
    [ActionType.StartExecution]: () => svc.executePaymentById(id),
    [ActionType.Refund]: () => svc.refundWithdrawById(id),
    [ActionType.Approve]: () =>
      svc.approveWithdrawalById(id, { comment: "N/A" }),
    [ActionType.Cancel]: () => svc.cancelWithdrawalById(id),
  }[_action];
  if (!_handler) {
    MsgPrompt.error("fail");
    return;
  }
  openConfirmBox(() =>
    _handler()
      .then(() => MsgPrompt.success())
      .then(() => {
        fecthAll();
      })
  );
};

const openApprovePanel = (id: number) => {
  confirmCommentBoxRef.value?.show?.((form: any) =>
    svc
      .approveWithdrawalById(id, { comment: form.comment })
      .then(() => MsgPrompt.success())
      .then(() => {
        fecthAll();
      })
  );
};

const openRejectPanel = (id: number) => {
  openRejectBox?.((form: any) =>
    svc
      .rejectWithdrawalById(id, { id, reason: form.reason })
      .then(() => MsgPrompt.success())
      .then(() => {
        fetchData(criteria.value.page);
      })
  );
};

const openVerifyApprovePanel = (id: number) => {
  // approve 只弹普通确认框，不需要填 comment
  openConfirmBox?.(() =>
    svc
      .approveWithdrawalVerifyById(id)
      .then(() => MsgPrompt.success())
      .then(() => {
        withdrawalPaymentInfoVerifyRef.value?.hide();
        fecthAll();
      })
  );
};

const openVerifyRejectPanel = (id: number) => {
  openRejectBox?.((form: any) =>
    svc
      .rejectWithdrawalVerifyById(id)
      .then(() => svc.rejectWithdrawalById(id, { id, reason: form.reason }))
      .then(() => MsgPrompt.success())
      .then(() => {
        withdrawalPaymentInfoVerifyRef.value?.hide();
        fetchData(criteria.value.page);
      })
  );
};

const openRejectRestorePanel = (id: number) => {
  openConfirmBox?.(() =>
    svc
      .restoreRejectedWithdrawalById(id)
      .then(() => MsgPrompt.success())
      .then(() => {
        fetchData(criteria.value.page);
      })
  );
};

const openCancelRestorePanel = (id: number) => {
  openConfirmBox?.(() =>
    svc
      .restoreCanceledWithdrawalById(id)
      .then(() => MsgPrompt.success())
      .then(() => {
        fetchData(criteria.value.page);
      })
  );
};

const fecthAll = async () => {
  isLoadingAll.value = true;
  await fetchData(criteria.value.page);
  if (tab.value == TabStatus.Pending) {
    await fetchDealingData(dealingCriteria.value.page);
  }
  isLoadingAll.value = false;
};

onMounted(async () => {
  await fecthAll();
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_BalanceShow = _resolveComponent("BalanceShow")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderMenu, {
      tabs: _unref(TabStatus),
      onChangeTab: changeTab,
      ref_key: "headerMenuRef",
      ref: headerMenuRef
    }, null, 8, ["tabs"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_date_picker, {
              class: "w-250px",
              modelValue: period.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((period).value = $event)),
              type: "daterange",
              "start-placeholder": _ctx.$t('fields.startDate'),
              "end-placeholder": _ctx.$t('fields.endDate'),
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"]),
            (tab.value === _unref(TabStatus).All)
              ? (_openBlock(), _createBlock(_component_el_select, {
                  key: 0,
                  modelValue: criteria.value.stateId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.stateId) = $event)),
                  onChange: confirmSearch,
                  class: "w-150px",
                  placeholder: _ctx.$t('fields.status'),
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: null,
                      label: _ctx.$t('fields.all')
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WithdrawalStateTypes), (status) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: status,
                        value: status,
                        label: _ctx.$t(`type.transactionState.${status}`)
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_input, {
              modelValue: criteria.value.accountNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.accountNumber) = $event)),
              class: "w-200px",
              placeholder: _ctx.$t('fields.accountNumber'),
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_el_input, {
              modelValue: criteria.value.email,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.email) = $event)),
              class: "w-250px ms-2",
              placeholder: _ctx.$t('fields.email'),
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_el_input, {
              modelValue: criteria.value.walletId,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.walletId) = $event)),
              class: "w-150px ms-2",
              placeholder: _ctx.$t('fields.walletId'),
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_el_input, {
              modelValue: criteria.value.paymentId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((criteria.value.paymentId) = $event)),
              class: "w-150px ms-2",
              placeholder: _ctx.$t('fields.paymentId'),
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"]),
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              onClick: confirmSearch
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              plain: "",
              type: "info",
              onClick: clearSearchFilterCriteria
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
              ]),
              _: 1
            }),
            (tab.value === _unref(TabStatus).All)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "success",
                  onClick: submitReportRequest,
                  loading: exporting.value,
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_5
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (tab.value == _unref(TransactionStateType).WithdrawalCreated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                (tab.value === _unref(TabStatus).All || tab.value === _unref(TabStatus).Pending)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "success",
                      onClick: submitReportRequest,
                      loading: exporting.value,
                      plain: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("action.export")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("table", _hoisted_11, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_12, [
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.client")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.info")), 1),
                (tab.value == _unref(TabStatus).All)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.status")), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentStatus")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentID")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentMethod")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.currency")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.withdrawAmount")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.exchangeRate")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.sourceBalance")), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.time")), 1),
                _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.paymentInfo")), 1),
                (tab.value != _unref(TransactionStateType).WithdrawalCreated)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.operatedBy")), 1))
                  : _createCommentVNode("", true),
                (
                    tab.value == _unref(TransactionStateType).WithdrawalCreated || tab.value == 0
                  )
                  ? (_openBlock(), _createElementBlock("th", _hoisted_16, _toDisplayString(_ctx.$t("action.action")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_17, [
                  _createVNode(_component_LoadingRing)
                ]))
              : (!isLoading.value && data.value.length === 0)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                    _createVNode(_component_NoDataBox)
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", null, [
                          (item.user)
                            ? (_openBlock(), _createBlock(_component_UserInfo, {
                                key: 0,
                                user: item.user,
                                class: "me-2"
                              }, null, 8, ["user"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(item.source.salesGroupName), 1),
                          _hoisted_20,
                          _createTextVNode(_toDisplayString(item.source.agentGroupName), 1)
                        ]),
                        (tab.value == _unref(TabStatus).All)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(_ctx.$t(`type.transactionState.${item.stateId}`)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", {
                        'badge-primary':
                          item.payment.status === _unref(PaymentStatusTypes).Pending,
                        'badge-success':
                          item.payment.status === _unref(PaymentStatusTypes).Completed,
                        'badge-danger':
                          item.payment.status === _unref(PaymentStatusTypes).Failed,
                        'badge-warning':
                          item.payment.status === _unref(PaymentStatusTypes).Executing,
                      }])
                            }, _toDisplayString(_ctx.$t(`type.paymentStatus.${item.payment.status}`)), 3),
                            _createVNode(_component_el_button, {
                              icon: _unref(Document),
                              circle: "",
                              onClick: ($event: any) => (historyRef.value.show(item.id))
                            }, null, 8, ["icon", "onClick"])
                          ])
                        ]),
                        _createElementVNode("td", {
                          onClick: ($event: any) => (
                    viewComments(
                      _unref(CommentType).Withdrawal,
                      item.id,
                      item.payment.number.substring(3)
                    )
                  )
                        }, [
                          _createTextVNode(_toDisplayString(item.payment.id), 1),
                          (item.hasComment)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_23),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, _toDisplayString(item.payment.paymentServiceName), 1),
                          (canVerifyPaymentInfo(item))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "badge badge-primary mt-2 cursor-pointer",
                                onClick: ($event: any) => (openPaymentInfoVerifyPanel(item))
                              }, _toDisplayString(_ctx.$t("action.review")), 9, _hoisted_25))
                            : (isPaymentInfoVerified(item))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: "badge badge-success mt-2 cursor-pointer",
                                  onClick: ($event: any) => (openPaymentInfoVerifyPanel(item))
                                }, _toDisplayString(_ctx.$t("status.paymentInfoVerifySuccess")), 9, _hoisted_26))
                              : (isPaymentInfoVerifyFailed(item))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "badge badge-danger mt-2 cursor-pointer",
                                    onClick: ($event: any) => (openPaymentInfoVerifyPanel(item))
                                  }, _toDisplayString(_ctx.$t("status.paymentInfoVerifyFailed")), 9, _hoisted_27))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_BalanceShow, {
                            "currency-id": item.currencyId,
                            balance: item.amount
                          }, null, 8, ["currency-id", "balance"])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.exchangeRate), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_BalanceShow, {
                              "currency-id": item.currencyId,
                              balance: 
                        item.source.accountType == 1
                          ? item.source.balanceInCents
                          : item.source.equityInCents
                      
                            }, null, 8, ["currency-id", "balance"])
                          ]),
                          (
                      item.source.accountType === _unref(TransactionAccountType).Wallet
                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Wallet # " + _toDisplayString(item.source.displayNumber), 1))
                            : _createCommentVNode("", true),
                          (
                      item.source.accountType ===
                      _unref(TransactionAccountType).TradeAccount
                    )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "badge badge-warning",
                                onClick: ($event: any) => (
                      viewComments(
                        _unref(CommentType).Account,
                        item.source.id,
                        item.source.displayNumber
                      )
                    )
                              }, [
                                _createTextVNode(" Account # " + _toDisplayString(item.source.displayNumber) + " ", 1),
                                (item.source.hasComment)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_30))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_29))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", null, [
                            _createVNode(_component_TimeShow, {
                              "date-iso-string": item.payment.createdOn
                            }, null, 8, ["date-iso-string"])
                          ]),
                          (item.payment.createdOn != item.payment.updatedOn)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createVNode(_component_TimeShow, {
                                  "date-iso-string": item.payment.updatedOn
                                }, null, 8, ["date-iso-string"])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_32, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "btn btn-sm btn-light-info fw-bold ms-2 fs-8 py-1 px-3",
                            onClick: ($event: any) => (showWithdrawInfo(item))
                          }, _toDisplayString(_ctx.$t("action.showPaymentInfo")), 9, _hoisted_33)
                        ]),
                        (tab.value != _unref(TabStatus).Pending)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                              (
                      item.stateId != _unref(TransactionStateType).WithdrawalCreated
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(item.operatorName), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("td", _hoisted_36, [
                          (
                      item.stateId == _unref(TransactionStateType).WithdrawalCreated
                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                _createElementVNode("button", {
                                  disabled: 
                        (item.source.accountType == 1
                          ? item.source.balanceInCents
                          : item.source.equityInCents) < item.amount
                      ,
                                  class: "btn btn-light btn-primary btn-sm me-3",
                                  onClick: ($event: any) => (
                        item.source.accountType ===
                        _unref(TransactionAccountTypes).Wallet
                          ? openConfirmPanel(_unref(ActionType).Approve, item.id)
                          : openApprovePanel(item.id)
                      )
                                }, [
                                  (
                          (item.source.accountType == 1
                            ? item.source.balanceInCents
                            : item.source.equityInCents) < item.amount
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("status.notAllowed")), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t("action.approve")), 1)
                                      ], 64))
                                ], 8, _hoisted_38),
                                _createElementVNode("button", {
                                  href: "#",
                                  class: "btn btn-light btn-danger btn-sm",
                                  onClick: ($event: any) => (openRejectPanel(item.id))
                                }, _toDisplayString(_ctx.$t("action.reject")), 9, _hoisted_39),
                                _createElementVNode("button", {
                                  href: "#",
                                  class: "btn btn-light btn-light-danger btn-sm ms-3",
                                  onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Cancel, item.id))
                                }, _toDisplayString(_ctx.$t("action.cancel")), 9, _hoisted_40)
                              ]))
                            : _createCommentVNode("", true),
                          (
                      item.stateId ==
                      _unref(TransactionStateType).WithdrawalTenantApproved
                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                (item.payment.status === _unref(PaymentStatusTypes).Pending)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "btn btn-light btn-success btn-sm me-3",
                                      onClick: ($event: any) => (
                        openConfirmPanel(
                          _unref(ActionType).StartExecution,
                          item.payment.id
                        )
                      )
                                    }, _toDisplayString(_ctx.$t("action.startProcess")), 9, _hoisted_42))
                                  : (
                        item.payment.status === _unref(PaymentStatusTypes).Executing
                      )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn btn-light btn-info btn-sm me-3",
                                        onClick: ($event: any) => (
                        openConfirmPanel(
                          _unref(ActionType).CompletePayment,
                          item.id,
                          item.payment.id
                        )
                      )
                                      }, _toDisplayString(_ctx.$t("action.complete")), 9, _hoisted_43))
                                    : _createCommentVNode("", true),
                                (_ctx.$can('TenantAdmin') || _ctx.$can('SuperAdmin'))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      class: "btn btn-light btn-light-danger btn-sm me-3",
                                      onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Refund, item.id))
                                    }, _toDisplayString(_ctx.$t("action.refund")), 9, _hoisted_44))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (
                      item.stateId ==
                      _unref(TransactionStateType).WithdrawalTenantRejected
                    )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "btn btn-light btn-danger btn-sm me-3",
                                onClick: ($event: any) => (openRejectRestorePanel(item.id))
                              }, _toDisplayString(_ctx.$t("action.restore")), 9, _hoisted_45))
                            : _createCommentVNode("", true),
                          (
                      item.stateId == _unref(TransactionStateType).WithdrawalCanceled
                    )
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                class: "btn btn-light btn-danger btn-sm me-3",
                                onClick: ($event: any) => (openCancelRestorePanel(item.id))
                              }, _toDisplayString(_ctx.$t("action.restore")), 9, _hoisted_46))
                            : _createCommentVNode("", true),
                          (_ctx.$can('SuperAdmin'))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                class: "btn btn-light btn-warning btn-sm me-3",
                                onClick: ($event: any) => (changeStatusRef.value?.show(item))
                              }, _toDisplayString(_ctx.$t("action.changeStatus")), 9, _hoisted_47))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
          ]),
          _createVNode(_component_TableFooter, {
            onPageChange: pageChange,
            criteria: criteria.value
          }, null, 8, ["criteria"])
        ])
      ]),
      (tab.value == _unref(TabStatus).Pending)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              (tab.value == _unref(TransactionStateType).WithdrawalCreated)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, " 財務部門 審核 "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("table", _hoisted_52, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_53, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.client")), 1),
                    (tab.value == _unref(TabStatus).All)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_54, _toDisplayString(_ctx.$t("fields.status")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentStatus")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentID")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.paymentMethod")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.currency")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.withdrawAmount")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.sourceBalance")), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
                    _createElementVNode("th", _hoisted_55, _toDisplayString(_ctx.$t("fields.paymentInfo")), 1),
                    _createElementVNode("th", _hoisted_56, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
                    _createElementVNode("th", _hoisted_57, _toDisplayString(_ctx.$t("action.action")), 1),
                    _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.$t("action.refund")), 1)
                  ])
                ]),
                (isDealingLoading.value || isLoadingAll.value)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_59, [
                      _createVNode(_component_LoadingRing)
                    ]))
                  : (
                !isDealingLoading.value && !isLoadingAll.value && dataDealing.value.length === 0
              )
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_60, [
                        _createVNode(_component_NoDataBox)
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_61, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataDealing.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_62, [
                              (item.user)
                                ? (_openBlock(), _createBlock(_component_UserInfo, {
                                    key: 0,
                                    user: item.user,
                                    class: "me-2"
                                  }, null, 8, ["user"]))
                                : _createCommentVNode("", true)
                            ]),
                            (tab.value == _unref(TabStatus).All)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_63, _toDisplayString(_ctx.$t(`type.transactionState.${item.stateId}`)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", {
                        'badge-primary':
                          item.payment.status === _unref(PaymentStatusTypes).Pending,
                        'badge-success':
                          item.payment.status === _unref(PaymentStatusTypes).Completed,
                        'badge-danger':
                          item.payment.status === _unref(PaymentStatusTypes).Failed,
                        'badge-warning':
                          item.payment.status === _unref(PaymentStatusTypes).Executing,
                      }])
                                }, _toDisplayString(_ctx.$t(`type.paymentStatus.${item.payment.status}`)), 3),
                                _createVNode(_component_el_button, {
                                  icon: _unref(Document),
                                  circle: "",
                                  onClick: ($event: any) => (historyRef.value.show(item.id))
                                }, null, 8, ["icon", "onClick"])
                              ])
                            ]),
                            _createElementVNode("td", {
                              onClick: ($event: any) => (
                    viewComments(
                      _unref(CommentType).Withdrawal,
                      item.id,
                      item.payment.number.substring(3)
                    )
                  )
                            }, [
                              _createTextVNode(_toDisplayString(item.payment.id), 1),
                              (item.hasComment)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_66))
                                : _createCommentVNode("", true)
                            ], 8, _hoisted_65),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", null, _toDisplayString(item.payment.paymentServiceName), 1),
                              (canVerifyPaymentInfo(item))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "badge badge-primary mt-2 cursor-pointer",
                                    onClick: ($event: any) => (openPaymentInfoVerifyPanel(item))
                                  }, _toDisplayString(_ctx.$t("action.review")), 9, _hoisted_67))
                                : (isPaymentInfoVerified(item))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "badge badge-success mt-2 cursor-pointer",
                                      onClick: ($event: any) => (openPaymentInfoVerifyPanel(item))
                                    }, _toDisplayString(_ctx.$t("status.paymentInfoVerifySuccess")), 9, _hoisted_68))
                                  : (isPaymentInfoVerifyFailed(item))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 2,
                                        class: "badge badge-danger mt-2 cursor-pointer",
                                        onClick: ($event: any) => (openPaymentInfoVerifyPanel(item))
                                      }, _toDisplayString(_ctx.$t("status.paymentInfoVerifyFailed")), 9, _hoisted_69))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                            _createElementVNode("td", null, [
                              _createVNode(_component_BalanceShow, {
                                "currency-id": item.currencyId,
                                balance: item.amount
                              }, null, 8, ["currency-id", "balance"])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_BalanceShow, {
                                  "currency-id": item.currencyId,
                                  balance: 
                        item.source.accountType == 1
                          ? item.source.balanceInCents
                          : item.source.equityInCents
                      
                                }, null, 8, ["currency-id", "balance"])
                              ]),
                              (
                      item.source.accountType === _unref(TransactionAccountType).Wallet
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, " Wallet # " + _toDisplayString(item.source.displayNumber), 1))
                                : _createCommentVNode("", true),
                              (
                      item.source.accountType ===
                      _unref(TransactionAccountType).TradeAccount
                    )
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: "badge badge-warning",
                                    onClick: ($event: any) => (
                      viewComments(
                        _unref(CommentType).Account,
                        item.source.id,
                        item.source.displayNumber
                      )
                    )
                                  }, [
                                    _createTextVNode(" Account # " + _toDisplayString(item.source.displayNumber) + " ", 1),
                                    (item.source.hasComment)
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_72))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_71))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_TimeShow, {
                                  "date-iso-string": item.payment.createdOn
                                }, null, 8, ["date-iso-string"])
                              ]),
                              (item.payment.createdOn != item.payment.updatedOn)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                    _createVNode(_component_TimeShow, {
                                      "date-iso-string": item.payment.updatedOn
                                    }, null, 8, ["date-iso-string"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_74, [
                              _createElementVNode("a", {
                                href: "#",
                                class: "btn btn-sm btn-light-info fw-bold ms-2 fs-8 py-1 px-3",
                                onClick: ($event: any) => (showWithdrawInfo(item))
                              }, _toDisplayString(_ctx.$t("action.showPaymentInfo")), 9, _hoisted_75)
                            ]),
                            (item.stateId != _unref(TransactionStateType).WithdrawalCreated)
                              ? (_openBlock(), _createElementBlock("td", _hoisted_76, _toDisplayString(item.operatorName), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_77, [
                              (item.payment.status === _unref(PaymentStatusTypes).Pending)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-light btn-success btn-sm me-3",
                                    onClick: ($event: any) => (
                      openConfirmPanel(
                        _unref(ActionType).StartExecution,
                        item.payment.id
                      )
                    )
                                  }, _toDisplayString(_ctx.$t("action.startProcess")), 9, _hoisted_78))
                                : (
                      item.payment.status === _unref(PaymentStatusTypes).Executing ||
                      item.payment.status === _unref(PaymentStatusTypes).Completed
                    )
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      class: "btn btn-light btn-info btn-sm me-3",
                                      onClick: ($event: any) => (
                      openConfirmPanel(
                        _unref(ActionType).CompletePayment,
                        item.id,
                        item.payment.id
                      )
                    )
                                    }, _toDisplayString(_ctx.$t("action.complete")), 9, _hoisted_79))
                                  : _createCommentVNode("", true),
                              (_ctx.$can('SuperAdmin'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 2,
                                    class: "btn btn-light btn-warning btn-sm me-3",
                                    onClick: ($event: any) => (changeStatusRef.value?.show(item))
                                  }, _toDisplayString(_ctx.$t("action.changeStatus")), 9, _hoisted_80))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_81, [
                              (_ctx.$can('TenantAdmin') || _ctx.$can('SuperAdmin'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-light btn-light-danger btn-sm me-3",
                                    onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Refund, item.id))
                                  }, _toDisplayString(_ctx.$t("action.refund")), 9, _hoisted_82))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ]))
              ]),
              _createVNode(_component_TableFooter, {
                onPageChange: fetchDealingData,
                criteria: dealingCriteria.value
              }, null, 8, ["criteria"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(WithdrawInfo, {
      ref_key: "WithdrawInfoRef",
      ref: WithdrawInfoRef,
      fromDealing: viewingFromDealing.value
    }, null, 8, ["fromDealing"]),
    _createVNode(CommentsView, {
      ref_key: "commentsRef",
      ref: commentsRef,
      type: "",
      id: "0"
    }, null, 512),
    _createVNode(ChangeStatusModal, {
      ref_key: "changeStatusRef",
      ref: changeStatusRef
    }, null, 512),
    _createVNode(ConfirmBox, {
      ref: "confirmBoxRef",
      "is-loading": isSubmitting.value,
      handleConfirm: processTransaction.value,
      "confirm-color": 
        {
          [_unref(ActionType).Approve]: 'primary',
          [_unref(ActionType).Reject]: 'danger',
          [_unref(ActionType).Cancel]: 'success',
          [_unref(ActionType).CompletePayment]: 'info',
          [_unref(ActionType).Complete]: 'warning',
        }[action.value]
      
    }, null, 8, ["is-loading", "handleConfirm", "confirm-color"]),
    _createVNode(ConfirmCommentBox, {
      ref_key: "confirmCommentBoxRef",
      ref: confirmCommentBoxRef,
      hasComment: true
    }, null, 512),
    _createVNode(NewWithdrawalRequestModal, {
      ref_key: "newWithdrawalRequestModalRef",
      ref: newWithdrawalRequestModalRef
    }, null, 512),
    _createVNode(WithdrawalPaymentInfoVerify, {
      ref_key: "withdrawalPaymentInfoVerifyRef",
      ref: withdrawalPaymentInfoVerifyRef,
      "approve-handler": openVerifyApprovePanel,
      "reject-handler": openVerifyRejectPanel
    }, null, 512),
    _createVNode(HistoryRecord, {
      ref_key: "historyRef",
      ref: historyRef
    }, null, 512)
  ]))
}
}

})